import { render, staticRenderFns } from "./Adv.vue?vue&type=template&id=b473054c&"
import script from "./Adv.vue?vue&type=script&lang=js&"
export * from "./Adv.vue?vue&type=script&lang=js&"
import style0 from "./Adv.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports